var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 129.745 33.553",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: "{0.977} ",
    d: "M48.524 196.152h5.898v-31.085h-5.917l-7.357 5.579v5.773l7.258-5.385h.118zM73.81 196.69c6.884 0 11.874-4.718 12.426-11.33l.02-.238h-5.799l-.04.216c-.768 3.683-3.175 5.837-6.607 5.837-4.556 0-7.475-4.05-7.475-10.598v-.022c0-6.505 2.92-10.512 7.475-10.512 3.55 0 5.878 2.24 6.549 5.665l.079.367h5.798l-.02-.194c-.552-6.592-5.502-11.353-12.406-11.353-8.303 0-13.55 6.032-13.55 16.049v.021c0 10.017 5.227 16.092 13.55 16.092zM89.925 196.152h18.856v-5.364h-12.9v-7.82h12.17v-5.084H95.88v-7.453h12.9v-5.364H89.925ZM113.08 196.152h5.957v-11.267h4.773l5.306 11.267h6.746l-5.996-12.236c3.155-1.357 5.147-4.761 5.147-8.854v-.043c0-6.247-3.786-9.952-10.177-9.952H113.08zm5.957-16.2v-9.801h5.07c2.938 0 4.812 1.895 4.812 4.868v.043c0 3.059-1.776 4.89-4.734 4.89z",
    transform: "translate(-41.148 -163.137)",
    strokeWidth: "{0.264583} "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0.15em",
    fill: "none",
    opacity: "{0.977} ",
    strokeLinejoin: "round",
    d: "M140.323 166.852h24.723c.946 0 1.713.712 1.713 1.59v24.968c0 .879-.767 1.59-1.713 1.59h-24.723c-.946 0-1.712-.711-1.712-1.59v-24.967c0-.879.766-1.59 1.712-1.59z",
    strokeLinecap: "round",
    stroke: "#000",
    transform: "translate(-41.148 -163.137)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    opacity: "{0.977} ",
    strokeLinejoin: "round",
    strokeWidth: "0.15em",
    fill: "none",
    stroke: "#000",
    d: "M142.684 174.726c5.952 7.032 10.66 15.362 10.66 15.362s5.928-14.545 16.226-25.628",
    transform: "translate(-41.148 -163.137)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.488a7996fac11fb1f9a5c2da01279fbd.svg";
export { ForwardRef as ReactComponent };